export default __webpack_public_path__ + "static/media/mosquitera-fija-clipada-card.54c426e9.jpg";